import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button, I } from '@leanin/ui';
import { FlowShell, type FlowStep } from '@/components/onboarding/FlowShell';
import {
  ChecklistColumn,
} from '@/components/onboarding/ChecklistColumn';
import { useFinishOnboarding } from '@/components/onboarding/finish-onboarding';
import { STEP_CONTENT_BY_KEY } from '@/components/onboarding/checklist-registry';
import { PERSONA_STEP_KEYS } from '@/components/onboarding/persona-steps';

const STEPS: ReadonlyArray<FlowStep> = [
  { label: 'Welcome' },
  { label: 'Lean In Circles' },
  { label: 'Get involved' },
  { label: 'Build leadership skills' },
  { label: "You're in" },
];

export const Route = createFileRoute('/onboarding/complete')({
  component: OnboardingCompletePage,
});

function OnboardingCompletePage() {
  const navigate = useNavigate();
  const finish = useFinishOnboarding('li');
  return (
    <FlowShell
      role="Lean In Member"
      stepIndex={4}
      steps={STEPS}
      title="Let's get started."
      primary={
        <Button variant="primary" icon={I.arrow} onClick={() => void finish()}>
          Finish onboarding
        </Button>
      }
      secondary={
        <Button
          variant="ghost"
          onClick={() => navigate({ to: '/onboarding/welcome' })}
        >
          Return to welcome message
        </Button>
      }
    >
      <ChecklistColumn
        eyebrow="Next steps"
        title="Your Lean In Member Checklist"
        items={PERSONA_STEP_KEYS['lean-in'].map((key) => {
          const { title, sub, cta, href } = STEP_CONTENT_BY_KEY[key];
          return { title, sub, cta, href };
        })}
        onNavigate={(href) => void finish(href)}
      />
    </FlowShell>
  );
}
